import z from 'zod';

export const ZPaymentStatusSchema = z.object({
  display: z.boolean(),
  url: z.string().optional(),
  cartId: z.string().optional(),
});
